<template>
    <performance-common-dialog
        :title="'轨迹回放'"
        ref="performanceCommonDialog"
        @close="dialogClose"
    >
        <template #top> </template>
    </performance-common-dialog>
</template>
<script>
import PerformanceCommonDialog from '@/modules/transport/otp/components/PerformanceCommonDialog';

export default {
    name: 'dispatchArrivalRegistration',
    components: { PerformanceCommonDialog },
    data () {
        return {
        };
    },
    methods: {
        dialogClose () {
            this.$emit('components-close');
        }

    },
    mounted () {
        this.$refs.performanceCommonDialog.show();
    }

};
</script>

<style scoped lang="less">
</style>
